import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { facilityStayAction } from 'src/redux/actions/constant';
import facilityStayService from 'src/services/apiServices/facilityStayService';

const { REQUEST_CREATE_FACILITY_STAY, SUCCESS_CREATE_FACILITY_STAY, FAILURE_CREATE_FACILITY_STAY,CREATE_FACILITY_LOADING } =
  facilityStayAction;

function* createFacilitiesStay(action: any): SagaReturnType<any> {
  try {
    yield put({type:CREATE_FACILITY_LOADING})
    const response = yield call(facilityStayService.createFacilityStay, action.payload);
    if (response?.status === 201) {
      yield put({ type: SUCCESS_CREATE_FACILITY_STAY, payload: response });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_CREATE_FACILITY_STAY, payload: error });
  }
}

function* createFacilitiesStaySaga() {
  yield takeEvery(REQUEST_CREATE_FACILITY_STAY, createFacilitiesStay);
}

export default createFacilitiesStaySaga;
